'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactChildrenUtilities = require('react-children-utilities');

var _reactChildrenUtilities2 = _interopRequireDefault(_reactChildrenUtilities);

var _ModalAction = require('./ModalAction');

var _ModalAction2 = _interopRequireDefault(_ModalAction);

var _ModalWrapper = require('./ModalWrapper');

var _ModalWrapper2 = _interopRequireDefault(_ModalWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalFooter = function ModalFooter(_ref) {
    var children = _ref.children,
        noActionsWrapper = _ref.noActionsWrapper,
        noFooterWrapper = _ref.noFooterWrapper,
        toggleModal = _ref.toggleModal;

    var actions = _reactChildrenUtilities2.default.deepMap(children, function (child) {
        return child.type === _ModalAction2.default ? _react2.default.cloneElement(child, {
            closeModal: toggleModal
        }) : null;
    });
    var filteredChildren = _reactChildrenUtilities2.default.filter(children, function (child) {
        return child.type !== _ModalAction2.default;
    });
    var wrap = function wrap(component, condition) {
        return condition ? component : _react2.default.createElement(_ModalWrapper2.default, null, component);
    };
    return _react2.default.createElement("footer", { className: "luna-modal__footer" }, filteredChildren && filteredChildren.length > 0 && wrap(filteredChildren, noFooterWrapper), actions && actions.length > 0 && wrap(_react2.default.createElement("div", { className: "luna-modal__actions" }, actions), noActionsWrapper));
};
ModalFooter.propTypes = {
    toggleModal: _propTypes2.default.func.isRequired,
    children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.array]).isRequired,
    noActionsWrapper: _propTypes2.default.bool.isRequired,
    noFooterWrapper: _propTypes2.default.bool.isRequired
};
exports.default = ModalFooter;
//# sourceMappingURL=ModalFooter.js.map